module.exports = __webpack_public_path__ + "static/logo-bffd778e6a1ac2cebb31f569d545f0ad.png";